module.exports = __webpack_public_path__ + "static/media/logo.c1df0bc1.png";